import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pencil_outline",
  "use": "pencil_outline-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"pencil_outline\"><path d=\"M9.76 0c-1.13 0-2.2.45-3 1.24L6 2 4.94 3.06.5 7.5 0 14l6.5-.5 6.26-6.26a4.242 4.242 0 00-3-7.24zm1.94 6.18l-5.86 5.86-2.26.17c-.21-.43-.49-.82-.84-1.15-.28-.26-.6-.48-.95-.65l.17-2.25L6 4.12 8.38 6.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44L7.06 3.06l.76-.76a2.744 2.744 0 013.88 3.88z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol